// extracted by mini-css-extract-plugin
export default {"button":"RIDDm6"};